(function ($) {
  Drupal.behaviors.sppBundleLayoutV1 = {
    attach: function (context, settings) {
      var $modules = $('.js-spp-bundle-layout', context);

      $modules.each(function (i, obj) {
        var $bundle = $(obj);
        var $flow = $('.js-spp-bundle-layout-flow', $bundle);
        // BundleFlowState/BundleFlowDirector are in js/shared/bundle_flow.js
        var bundle_state = new site.bundleflow.BundleFlowState($flow);
        var bundleflow = new site.bundleflow.BundleFlowDirector($flow, bundle_state);
        var $bundle_items_carousel = $('.bundle-items-inside', $bundle);

        // clicking on what's inside block triggers overlay
        $bundle_items_carousel.on('click', '.js-product a[href]', function (e) {
          var $product = $(this);

          e.preventDefault();
          bundleflow.open_in_overlay();
        });

        window._bundleflow = bundleflow; // for debug
      });
    }
  };
})(jQuery);
